<template>
    <div class="container">
        <form class="login-form" @submit.prevent>
            <b-notification v-bind:type="$store.state.ui.toastType" :active="$store.state.ui.toast" :closable="false">
                {{$store.state.ui.toastMessage}}
            </b-notification>
            <div class="splash">Blackblox</div>
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" type="text" :placeholder="$t('login.email')" name="email" v-model="user.username" required
                           autofocus autocapitalize="none"/>
                    <span class="icon is-small is-left">
                        <i class="fas fa-user"></i>
                    </span>
                </div>
            </div>
            <div class="field">
                <div class="control has-icons-left has-icons-right">
                    <input class="input" v-bind:type="showPassword" :placeholder="$t('login.password')" name="password"
                           v-model="user.password" required/>
                    <span class="icon is-small is-left">
                        <i class="fas fa-key"></i>
                    </span>
                    <span class="icon is-small is-right clickable" @click="togglePass()">
                        <i class="fas fa-eye"></i>
                    </span>
                </div>
            </div>
            <input class="button is-primary" type="submit" :value="$t('login.log_in')" @click="doLogin()" :disabled="!inputValid"/>

            <div style="margin: 20px;" v-if="registerUserEnabled">
                {{ $t('login.new_user') }}
                <router-link to="/registration">{{ $t('login.register_here') }}</router-link>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: 'LoginView',
    data() {
        return {
            user: {
                username: '',
                password: ''
            },
            showPassword: 'password',
            registerUserEnabled: false
        };
    },
    methods: {
        doLogin() {
            // special username commands !api: and !reset:
            if (this.user.username.charAt(0) === '!') {
                if (this.user.username.indexOf('!api:') === 0) {
                    this.$store.dispatch('data/NEW_API', this.user.username.substring(5));
                    window.location.reload();
                } else if (this.user.username.indexOf('!reset:') === 0) {
                    this.$store.dispatch('data/RESET');
                    window.location.reload();
                } else {
                    console.log('Unknown command!');
                }
            } else {
                this.$store.commit('toast', []);
                this.$store.dispatch('doLogin', this.user)
                    .then((response) => {
                        this.user.password = '';
                    })
                    .catch((error) => {
                        if (error.message === 'credentials') {
                            this.$store.commit('toast', ['is-danger', 'Incorrect username or password']);
                        } else if (error.message === 'connection') {
                            this.$store.commit('toast', ['is-danger', 'Could not establish connection']);
                        } else {
                            this.$store.commit('toast', ['is-danger', 'Unknown error']);
                        }
                    });
            }
        },
        togglePass() {
            if (this.showPassword === 'password') {
                this.showPassword = 'text';
            } else {
                this.showPassword = 'password';
            }
        },
        async checkRegistrationStatus() {
            try {
                let API_URL = process.env.VUE_APP_API_BASE;
                // Make the API call to check registration status
                const response = await fetch(API_URL + '/api/v2/public/register');

                // Check if the response content type is JSON
                const contentType = response.headers.get("Content-Type");

                if (contentType && contentType.includes("application/json")) {
                    const data = await response.json(); // Parse JSON if content type is JSON
                    this.registerUserEnabled = data.registerUserEnabled;
                } else {
                    console.error('Expected JSON, but received:', contentType);
                    this.registerUserEnabled = false;
                }
            } catch (error) {
                console.error('Failed to check registration status', error);
                this.registerUserEnabled = false;
            }
        }
    },
    computed: {
        inputValid() {
            return (this.user.username && this.user.username.charAt(0) === '!') || ((this.user.username && this.user.username.length > 0) && (this.user.password && this.user.password.length > 0));
        }
    },
    mounted() {
        this.checkRegistrationStatus();
    }
};
</script>

<style scoped lang="scss">
    .control .icon.clickable {
        pointer-events: all;
        cursor: pointer;

        &:hover {
            color: #5e6d6f;
        }
    }

    .container {
        height: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .login-form {
        width: 250px;
        margin: auto;
        text-align: center;

        .splash {
            font-size: 2em;
        }
    }

    .notification {
        padding: 1em;
        text-align: center;
        position: absolute;
        top: 1em;
        margin: auto;
        width: 40%;
        left: 0;
        right: 0;
    }

</style>
